//@flow

import React, {Component} from "react"
import DateRangePicker from 'react-bootstrap-daterangepicker'
import '../../themes/daterangepicker/daterangepicker.css'
import '../../themes/daterangepicker/custom.scss'

import moment from 'moment'
import type Moment from 'moment'

import {formatInLocalTimeZone, parse} from '../util/DateUtil'
import {injectIntl} from "react-intl"

type Props = {
  value: Moment,
  onApply?: (value: Moment) => void
}

class BootstrapSingleDatePicker extends Component {

  props: Props

  constructor(){
    super()
  }

  shouldComponentUpdate(nextProps: Props) {

    return nextProps.value !== this.props.value
  }

  render() {
    const formatMessage = this.props.intl.formatMessage
    const format = 'YYYY MMM DD HH:mm:ss'

    const value = this.props.value

    const fixDate = (p) => {
      p.startDate._isUTC = false
      p.endDate._isUTC = false
    }

    const onApply = this.props.onApply

    const defaultValue = moment()
    const configValue = value || defaultValue

    const dateRangePickerConfig = {
      // dateLimit: { years: 3},
      startDate: configValue,
      endDate: configValue,
      singleDatePicker: true,
      applyClass: 'no-margins',
      locale: {
        format
      },
      ranges: {},
      onApply: function (e, p) {
        fixDate(p)
        if (onApply) onApply(e, p.startDate)
      },
      onShow: function (e, p) {
        // fixDate(p)
      },
      onHide: function (e, p) {
        // fixDate(p)
      }
    }


    return (
      <DateRangePicker {...dateRangePickerConfig}>
        <div
          style={{
            background: '#fff',
            cursor: 'pointer',
            padding: '5px 10px',
            border: '1px solid #ccc',
            width: '320px'
          }}>
          <i className="glyphicon glyphicon-calendar fas fa-calendar-alt"></i>&nbsp;
          <span>
            {this.props.value?formatInLocalTimeZone(this.props.value, format):formatMessage({id:'please.select.date'})}
          </span>
          <b className="caret"></b>
        </div>
      </DateRangePicker>

    )
  }
}

export default injectIntl(BootstrapSingleDatePicker)



// WEBPACK FOOTER //
// ./src/components/BootstrapSingleDatePicker.js